import * as React from 'react';
import * as RxDropdown from '@radix-ui/react-dropdown-menu';
import { ChevronDown } from 'lucide-react';

// Themed wrapper for grouped secondary actions ("Salin sebagai cURL",
// "Bagikan request", etc). Renders a single neutral button that opens
// a dropdown — keeps the action bar tidy when there are more than 2
// secondary actions.

export interface ActionItem {
    label: string;
    icon?: React.ComponentType<{ className?: string }>;
    onSelect: () => void;
    disabled?: boolean;
}

interface Props {
    label: string;
    icon?: React.ComponentType<{ className?: string }>;
    items: ActionItem[];
    align?: 'start' | 'end' | 'center';
    className?: string;
}

export function ActionMenu({ label, icon: Icon, items, align = 'end', className = '' }: Props) {
    return (
        <RxDropdown.Root>
            <RxDropdown.Trigger asChild>
                <button
                    type="button"
                    className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-md text-xs text-muted hover:text-ink transition-colors ${className}`}
                    style={{ backgroundColor: 'var(--surface-1)', border: '1px solid var(--border)' }}
                >
                    {Icon && <Icon className="h-3 w-3" />}
                    <span>{label}</span>
                    <ChevronDown className="h-3 w-3 opacity-60" />
                </button>
            </RxDropdown.Trigger>

            <RxDropdown.Portal>
                <RxDropdown.Content
                    align={align}
                    sideOffset={6}
                    className="z-50 min-w-[200px] rounded-lg p-1 shadow-lg"
                    style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)' }}
                >
                    {items.map((it) => {
                        const ItemIcon = it.icon;
                        return (
                            <RxDropdown.Item
                                key={it.label}
                                onSelect={() => it.onSelect()}
                                disabled={it.disabled}
                                className="flex items-center gap-2.5 px-2.5 py-2 rounded-md text-xs outline-none cursor-pointer data-[highlighted]:bg-bg-hover data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed transition-colors"
                                style={{ color: 'var(--ink)' }}
                            >
                                {ItemIcon && <ItemIcon className="h-3.5 w-3.5 text-muted shrink-0" />}
                                <span className="flex-1">{it.label}</span>
                            </RxDropdown.Item>
                        );
                    })}
                </RxDropdown.Content>
            </RxDropdown.Portal>
        </RxDropdown.Root>
    );
}
